module.exports = __webpack_public_path__ + "img/swap-root.6da76dea.svg";